import { defineStore } from 'pinia'
import { api } from '@/plugins/api'

// ADAS Map Mobile access requests (Launchpad API accessRequest/*). Billing Admin (role 28)
// and Super Admin only on the API side.
export const accessRequestStore = defineStore('accessRequest', {
  state: () => ({
    requests: {
      count: 0,
      items: [],
      statusCounts: []
    },
    request: null,
    loading: {
      requests: false,
      request: false,
      saving: false
    }
  }),
  actions: {
    async getRequests(params) {
      this.loading.requests = true
      try {
        const data = await api.get('accessRequest/requests', params)
        this.requests = data || { count: 0, items: [], statusCounts: [] }
      } finally {
        this.loading.requests = false
      }
    },
    async getRequest(id) {
      this.loading.request = true
      try {
        this.request = await api.get('accessRequest/request', { id })
        return this.request
      } finally {
        this.loading.request = false
      }
    },
    clearRequest() {
      this.request = null
    },
    async searchUsers(search) {
      return (await api.get('accessRequest/users', { search })) || []
    },
    // Firms a requester's Launchpad user can be created in (name or NetSuite id, 2+ characters).
    async searchFirms(search) {
      return (await api.get('accessRequest/firms', { search })) || []
    },
    // The tier's holding firm for app users with no customer firm of their own; null when none is set up.
    async getHoldingFirm() {
      return (await api.get('accessRequest/holdingFirm')) || null
    },
    // Create the requester's Launchpad user (into data.firm, or the holding firm with data.useHoldingFirm)
    // and link it. Rejects with the API's message on 400 (can't) or 409 (stale).
    async createUser(data) {
      this.loading.saving = true
      try {
        this.request = await api.post('accessRequest/createUser', data)
        return this.request
      } finally {
        this.loading.saving = false
      }
    },
    // One reviewer action. Rejects with the API's message on 400 (not allowed) or 409 (stale).
    async updateRequest(data) {
      this.loading.saving = true
      try {
        this.request = await api.post('accessRequest/update', data)
        return this.request
      } finally {
        this.loading.saving = false
      }
    }
  }
})
